<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101003000011ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 예금 상품 상세(당좌예금(개인용))
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>당좌예금(개인용)</h2>
          </div>
          <div class="description">
            <p>
              현금카드(Eftpos 및 ATM)와 인터넷/모바일뱅킹 사용이 가능한 입출금이 자유로운 계좌(대월한도 당좌대출 설정가능 계좌)
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>당좌예금</dd>
            <dt>상품개요</dt>
            <dd>현금카드(Eftpos 및 ATM)와 인터넷/모바일뱅킹 사용이 가능한 입출금이 자유로운 계좌(대월한도 당좌대출 설정가능 계좌)</dd>
            <dt>가입대상</dt>
            <dd>실명의 개인</dd>
            <dt>계약기간</dt>
            <dd>제한없음</dd>
            <dt>가입통화</dt>
            <dd>NZD, USD, AUD, JPY, EUR</dd>
            <dt>가입금액</dt>
            <dd>
              신규가입 시 최저 NZD 20.00<br />
              (NZD 이외 기타통화는 0.00)
            </dd>
            <dt>금리 및 이율</dt>
            <dd>통화 : NZD</dd>
          </dl>
          <div class="tbl-top-etc">(연이율, 세전, 단위 : %)</div>
          <table class="table -type03">
            <thead>
              <tr>
                <th scope="col">Over $10,000</th>
                <th scope="col">Over $20,000</th>
                <th scope="col">Over $100,000</th>
                <th scope="col">Over $250,000</th>
                <th scope="col">Over $1,000,000</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 기타통화(USD, AUD, JPY, EUR) : 예금이율 0.00%</p>
            <p>· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>수수료</strong>
            <p class="side-arrow">후취수수료</p>
            <p>1) 계좌관리수수료</p>
            <p>2) 거래수수료</p>
            <p>- 입출금 창구이용료 NZ$0.50/건</p>
            <p>- ATM 이용 월 기준 1-5회 NZ$0.40/건(5회이상 NZ$0.75/건)</p>
            <p>- EFTPOS NZ$0.25/건</p>
            <p>- 수표사용수수료 : NZ$0.50/장</p>
          </div>

          <div class="info info-type4">
            <p class="side-arrow">현찰수수료</p>
            <p>1) NZD</p>

            <table class="table -type02">
              <colgroup>
                <col width="23%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">지폐</th>
                  <td>
                    <div class="info info-type4">
                      <p class="side-arrow">현금거래 및 현금입금</p>
                      <p>$3,000이상 초과액부터</p>
                      <p>$1,000당 $2.50</p>
                      <em></em>
                    </div>
                    <div class="info info-type4">
                      <p class="side-arrow">현금출금</p>
                      <p>$10,000이상 초과액부터</p>
                      <p>$1,000당 $2.50</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row" rowspan="2">동전</th>
                  <td>
                    <div class="info info-type4">
                      <p>$2.50 per $100 of gold coins</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="info info-type4">
                      <p>$2.50 per $10 of all other cents</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>2) NZD 외 영업점취급 외국통화(USD, AUD, JPY)</p>
            <p>- 외화계좌에 외화현찰 입금 시 입금금액 2% (Min $5)</p>
            <p>- 외화계좌에서 외화현찰 입금 시 출금액 1% (Min $5)</p>
          </div>

          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>신분증 (여권 또는 NZ운전면허증), 주소지 증명서 등</p>
            <p>※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.</p>
          </div>

          <div class="info info-type4">
            <strong>유의사항 및 기타</strong>
            <p>- 정기예금 및 대출 NZ$50,000 이상 시 후취수수료 면제</p>
            <p>- ATM 이용 현금인출금액 하루 최대 NZ$2,000</p>
            <p>- EFTPOS 이용 거래가능금액 하루 최대 NZ$5,000</p>
            <p>- 무승인 당좌대월 수수료 적용</p>
            <p>
              - 거래 유형 및 상품 종류 등에 따라 별도의 수수료 발생 <br />
              상기 수수료는 수시 변경될 수 있습니다.
            </p>
            <p>- 기타 자세한 내용은 영업점으로 문의하시기 바랍니다.</p>
          </div>
        </article>
      </div>
    </template>

    <!-- 영어 -->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>PERSONAL CHEQUE ACCOUNT</h2>
          </div>
          <div class="description">
            <p>
              A transactional account (can be set as the overdraft account) that can deposit/withdraw funds flexibly with access via Cash Card (Eftpos and ATM) and Internet/Mobile
              Banking.
            </p>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Cheque Account</dd>
            <dt>About the products</dt>
            <dd>
              A transactional account (can be set as the overdraft account) that can deposit/withdraw funds flexibly with access via Cash Card (Eftpos and ATM) and Internet/Mobile
              Banking.
            </dd>
            <dt>Eligibilty</dt>
            <dd>Personal customers</dd>
            <dt>Contract Terms</dt>
            <dd>No restrictions</dd>
            <dt>Available currency</dt>
            <dd>NZD, USD, AUD, JPY, EUR</dd>
            <dt>Deposit amount</dt>
            <dd>Minimum NZD 20.00 deposit required (For other currencies: No restrictions)</dd>
            <dt>Rates</dt>
            <dd>Currency : NZD</dd>
          </dl>
          <div class="tbl-top-etc">(Per Annum, pertax, unit : %)</div>
          <table class="table -type03">
            <thead>
              <tr>
                <th scope="col">Over $10,000</th>
                <th scope="col">Over $20,000</th>
                <th scope="col">Over $100,000</th>
                <th scope="col">Over $250,000</th>
                <th scope="col">Over $1,000,000</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
                <td>0.00</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Other currencies(USD, AUD, JPY, EUR) : interest rate 0.00%</p>
            <p>· All savings interest rates are subject to change according to market interest rate trends.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
            <p class="side-arrow">Monthly fees</p>
            <p>1) Account maintenance fee</p>
            <p>2) Transaction service fees</p>
            <p>- Deposit/withdrawal(Teller counter) NZ$0.50/per transaction</p>
            <p>- ATM : NZ$0.40 up to 5 times, NZ$0.75 for over</p>
            <p>- EFTPOS : NZ$0.25/per transaction</p>
            <p>- Cheque : NZ$0.50/per cheque</p>
          </div>

          <div class="info info-type4">
            <p class="side-arrow">Cash handing fees</p>
            <p>1) NZD</p>

            <table class="table -type02">
              <colgroup>
                <col width="23%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">Notes</th>
                  <td>
                    <div class="info info-type4">
                      <p class="side-arrow">Cash transactions/Cash deposits</p>
                      <p>Up to $3,000 Free</p>
                      <p>$2.50 over exceeding $1,000</p>
                      <em></em>
                    </div>
                    <div class="info info-type4">
                      <p class="side-arrow">Cash withdrawals</p>
                      <p>Up to $10,000 Free</p>
                      <p>$2.50 over exceeding $1,000</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row" rowspan="2">Coins</th>
                  <td>
                    <div class="info info-type4">
                      <p>$2.50 per $100 of gold coins</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="info info-type4">
                      <p>$2.50 per $10 of all other cents</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>2) USD, AUD, JPY (Notes only)</p>
            <p>- Foreign cash deposit to Foreign Currency Account : 2% of foreign amount (Minimum $5)</p>
            <p>- Foreign cash Withdrawal from Foreign Currency Account : 1% of foreign amount (Minimum $5)</p>
          </div>

          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>Passport or NZ driver's licence &amp; proof of address</p>
            <p>※ Please contact our branch for more detailed information on required documents.</p>
          </div>

          <div class="info info-type4">
            <strong>Notices and others</strong>
            <p>- With over NZ$50,000 of Term Deposit or Loan, No Monthly Fee</p>
            <p>- Daily ATM withdrawal limit of NZ$2,000</p>
            <p>- Daily EFTPOS transaction limit of NZ$5,000</p>
            <p>- Unarranged overdraft free may apply</p>
            <p>- Additional service fees may apply. Fees are subject to change from time to time.</p>
            <p>- For further details, please contact the branch.</p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
